import { welfareCommonConfig } from './common'
import type { WelfarePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

const primaryGradient = 'linear-gradient(90deg, #A66BFF 0%, #8E47FF 100%)'

export const theme = {
  btnBg: brandTheme.primaryColor,
  btnText: brandTheme.textInverse,
  coinsColor: brandTheme.primaryColor,
  coinsGradient: primaryGradient,
  actionGradient: brandTheme.primaryGradient,
  checkinBtnGradient: primaryGradient,
} as const

export const resources = {
  homeBg: '',
  welfareGold: '/images/novaris/welfare-gold.png',
  welfareBox: '/images/novaris/welfare-box.png',
} as const

export const welfareConfig: WelfarePageConfig = {
  theme,
  resources,
  texts: welfareCommonConfig.texts,
}
